module.exports = __webpack_public_path__ + "img/wastebox_gray.min.8e978b20.png";